module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "starknet.a4d930bd.png";